import { render, staticRenderFns } from "./DetailHeHuaChong.vue?vue&type=template&id=157fdb88&"
import script from "./DetailHeHuaChong.vue?vue&type=script&lang=js&"
export * from "./DetailHeHuaChong.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports